import axios from 'axios'
import constants from '../lib/constants'
import _ from 'lodash'

// CONSTANTS
export const GET_DEVICES = 'GET_DEVICES'
export const GET_DEVICES_COMPLETE = 'GET_DEVICES_COMPLETE'

export const GET_DEVICE = 'GET_DEVICE'
export const GET_DEVICE_COMPLETE = 'GET_DEVICE_COMPLETE'

// ACTIONS
let TOKEN = localStorage.getItem('authToken')

if (TOKEN) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${TOKEN}`
}

export const getDevices = () => {
  return (dispatch, getState) => {
    dispatch({ type: GET_DEVICES })
    return axios.get(`${constants.API_URL}/devices/internal/list`)
    .then((response) => {
      const sortedDevices = response.data.devices.sort((a, b) => (a.device_string > b.device_string ? 1 : -1))
      dispatch({
        type    : GET_DEVICES_COMPLETE,
        payload : {
          devices: sortedDevices,
        }
      })
      return response
    })
  }
}

export const getDevice = (deviceString) => {
  return (dispatch, getState) => {
    return axios.get(`${constants.API_URL}/devices/${deviceString}/`)
    .then((response) => {
      dispatch({
        type: GET_DEVICE_COMPLETE,
        payload: response.data
      })
    })
  }
}

export const associateDeviceWithUser = (deviceString, userId) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/devices/${deviceString}/associate_user`, {
      user_id: userId
    })
  }
}

export const dissociateDeviceWithUser = (deviceString, userId) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/devices/${deviceString}/dissociate_user`, {
      user_id: userId
    })
  }
}

export const startLensCalibration = (deviceString) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/devices/${deviceString}/set_status`, {
      status: 3
    })
    setTimeout(() => {
      dispatch(getDevice(deviceString))
    }, 15000)
    setTimeout(() => {
      dispatch(getDevice(deviceString))
    }, 30000)
    setTimeout(() => {
      dispatch(getDevice(deviceString))
    }, 45000)
  }
}

export const requestLogUpload = (deviceString) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/devices/${deviceString}/set_status`, {
      status: 4
    })
  }
}

export const calibrateStage = (deviceString) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/devices/${deviceString}/set_status`, {
      status: 8
    })
  }
}

export const restartDevice = (deviceString) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/devices/${deviceString}/set_status`, {
      status: 7
    })
  }
}

export const requestOnDeviceQCTest = (deviceString) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/devices/${deviceString}/set_status`, {
      status: 6
    })
  }
}

export const requestSpeedTest = (deviceString) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/devices/${deviceString}/set_status`, {
      status: 5
    })
    setTimeout(() => {
      dispatch(getDevice(deviceString))
    }, 15000)
  }
}

export const revokeToken = (deviceString) => {
  return (dispatch, getState) => {
    axios.post(`${constants.API_URL}/devices/${deviceString}/revoke_token`)
  }
}

// ACTION HANDLERS

const ACTION_HANDLERS = {
  [GET_DEVICES_COMPLETE] : (state, action) => {
    const { devices } = action.payload
    const newState = {
      ...state,
      devices
    }
    return newState
  },
  [GET_DEVICE_COMPLETE]: (state, action) => {
    const device = action.payload
    let newDevices = _.clone(state.devices)
    const matchingDeviceIndex = _.findIndex(newDevices, (d) => d.device_string === device.device_string)
    if (matchingDeviceIndex > -1) {
      newDevices[matchingDeviceIndex] = device
    } else {
      newDevices = [device]
    }
    return newDevices
  }
}

// REDUCER

const initialState = {
  devices: []
}

export default function sitesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/devices.js